import React from 'react'
import {
  KeapPartnerSecContentContainer,
  RightSection,
  LeftSection,
  KeapPartnerSidebarSubtitlePara,
  KeapPartnerSidebarNav,
  KeapPartnerSidebarSubtitle,
  KeapPartnerSidebarThryvLink,
  KeapPartnerImagePlay,
  KeapPartnerImage,
  CreateNShareSubtitle,
  CreateNShareHeading,
  CreateNShareContainer,
  CreateNShareContainerWrapper,
  NavbtnPlacement,
  KeapPartnerPrimaryBtn,
  KeapPartnerSecContentContainerWrapper,
} from './kp-landing-page-styles'
import {
  manAtThryv,
  PDFIconSm,
  toolsIconSm,
  raisedHand,
  commentDots,
  buttonPlay,
  ThryvLPVideoImg,
  buildLinkArrow,
} from '../../../assets'
import {useNavigate} from 'react-router'
import {useDispatch, useSelector} from 'react-redux'
import {setLinkType} from '../../../app-store/kpGlobalStateSlice'
import {selectEffectiveRole} from '../../../app-store/selector'

function LandingPageKP({userData}) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const roles = useSelector(selectEffectiveRole)
  const isKeapPartner = Array.isArray(roles) && roles.includes('KeapPartner')

  const handlePurchaseClick = linkType => {
    dispatch(setLinkType(linkType))
    // 1:Many picks its country inside the catalog; only 1:1 still uses the
    // separate country-selection page.
    if (linkType === '1:many') {
      navigate('/keap-partner-catalog', {
        state: {linkType, selectedCountry: isKeapPartner ? '' : 'US'},
      })
      return
    }
    navigate('/keap-partner-country-selection', {state: {linkType}})
  }

  return (
    <>
      <CreateNShareContainerWrapper>
        <CreateNShareContainer>
          <CreateNShareHeading>
            <div>Thryv Partners - Create & Share</div>
            <div>Buy Now Links</div>
          </CreateNShareHeading>
          <CreateNShareSubtitle>
            Check out this demo of our software to get you prepared for selling
            the stuff.
          </CreateNShareSubtitle>
          <KeapPartnerImage
            href="https://www.thryv.com/marketing-center/?wvideo=27uu6alyer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="partner-video"
              src={ThryvLPVideoImg}
              alt="Thryv partners Video"
            />
            <KeapPartnerImagePlay src={buttonPlay} alt="Play Button" />
          </KeapPartnerImage>
        </CreateNShareContainer>
      </CreateNShareContainerWrapper>

      <KeapPartnerSecContentContainerWrapper>
        <KeapPartnerSecContentContainer>
          <LeftSection>
            <img
              src={buildLinkArrow}
              style={{
                position: 'absolute',
                top: '-360px',
                left: '-120px',
                width: '286px',
                height: '382px',
              }}
              alt="buy now link builder arrow"
            />
            <KeapPartnerSidebarSubtitle>
              Proposal Tools & Resources
            </KeapPartnerSidebarSubtitle>
            <KeapPartnerSidebarSubtitlePara>
              Start here to create required proposals and access partner tools.
            </KeapPartnerSidebarSubtitlePara>
            <KeapPartnerSidebarNav>
              <KeapPartnerSidebarThryvLink
                href={'/marketing-center.pdf'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={PDFIconSm} alt="Marketing Center PDF" />
                Marketing Center PDF
              </KeapPartnerSidebarThryvLink>
              <KeapPartnerSidebarThryvLink
                href={'https://seodashboard.thryv.com/auth0/thryv'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={toolsIconSm} alt="SEO Proposal Tool" />
                SEO Proposal Tool
              </KeapPartnerSidebarThryvLink>
              <KeapPartnerSidebarThryvLink
                href={'https://thryv.jotform.com/251764288362869'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={raisedHand} alt="Thryv Leads Proposal Request" />
                Thryv Leads Proposal Request
              </KeapPartnerSidebarThryvLink>
              <KeapPartnerSidebarThryvLink
                href={'https://thryv.jotform.com/211234077295050'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={commentDots}
                  alt="Escalation, Request and Questions"
                />
                Thryv Leads-Submit Escalation, Change Request, or Product
                Questions
              </KeapPartnerSidebarThryvLink>
              <NavbtnPlacement style={{margin: '40px 0 0'}}>
                <KeapPartnerPrimaryBtn
                  onClick={() => {
                    handlePurchaseClick('1:Many')
                  }}
                >
                  1:MANY PURCHASE LINK
                </KeapPartnerPrimaryBtn>
              </NavbtnPlacement>
            </KeapPartnerSidebarNav>
          </LeftSection>
          <RightSection>
            <img src={manAtThryv} alt="employee at Thryv" />
          </RightSection>
        </KeapPartnerSecContentContainer>
      </KeapPartnerSecContentContainerWrapper>
    </>
  )
}

export {LandingPageKP}
